
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.043 20.586a8.2 8.2 0 003.305-.672 8.752 8.752 0 004.57-4.57 8.216 8.216 0 00.668-3.301 8.215 8.215 0 00-.668-3.3 8.716 8.716 0 00-1.85-2.725 8.703 8.703 0 00-2.73-1.85 8.246 8.246 0 00-3.304-.668c-1.16 0-2.256.223-3.287.668a8.702 8.702 0 00-2.729 1.85 8.717 8.717 0 00-1.85 2.725 8.215 8.215 0 00-.668 3.3 8.17 8.17 0 00.672 3.3 8.764 8.764 0 001.85 2.72 8.75 8.75 0 002.725 1.85 8.179 8.179 0 003.296.673zm-.062-11.514c-.328 0-.603-.113-.826-.338a1.126 1.126 0 01-.334-.822c0-.328.112-.605.334-.83.223-.226.498-.339.826-.339.317 0 .588.113.813.339.226.225.339.502.339.83 0 .322-.113.596-.339.822a1.109 1.109 0 01-.813.338zm2.04 7.69h-3.498a.666.666 0 01-.47-.184.61.61 0 01-.199-.466c0-.175.066-.328.198-.457a.65.65 0 01.47-.193h1.038v-3.727h-.888a.67.67 0 01-.475-.18.613.613 0 01-.193-.47.61.61 0 01.193-.453.653.653 0 01.475-.189h1.635c.234 0 .411.077.531.229.12.152.18.351.18.598v4.192h1.002c.188 0 .346.064.475.193a.625.625 0 01.194.457.617.617 0 01-.194.466.661.661 0 01-.474.185z","fill":"#41807A"}})])
          )
        }
      }
    